export default __webpack_public_path__ + "static/media/Gilroy-ExtraBold.126b049b.otf";